// frontend_react/src/services/activityApi.js

import api, { buildCompanyScopeHeaders } from "./api";

export const listActivities = ({ companyUuid } = {}) =>
  api.get("/activities", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const getActivity = (activityUuid, { companyUuid } = {}) =>
  api.get(`/activities/${activityUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const listActivityBlueprints = ({ companyUuid } = {}) =>
  api.get("/activities/blueprints", {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createActivity = (payload, { companyUuid } = {}) =>
  api.post("/activities", payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const updateActivity = (activityUuid, payload, { companyUuid } = {}) =>
  api.put(`/activities/${activityUuid}`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const reactivateActivity = (activityUuid, { companyUuid } = {}) =>
  api.post(`/activities/${activityUuid}/reactivate`, null, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const duplicateActivity = (activityUuid, payload = {}, { companyUuid } = {}) =>
  api.post(`/activities/${activityUuid}/duplicate`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteActivity = (activityUuid, payload = {}, { companyUuid } = {}) =>
  api.delete(`/activities/${activityUuid}`, {
    params: {
      delete_imported_data: payload.delete_imported_data ?? true,
    },
    data: {
      password: payload.password,
    },
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const getActivityProducts = (activityUuid, { companyUuid } = {}) =>
  api.get(`/activities/${activityUuid}/products`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const previewActivityProductImport = (
  activityUuid,
  formData,
  { companyUuid } = {}
) =>
  api.post(
    `/activities/${activityUuid}/products/import/preview`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...buildCompanyScopeHeaders(companyUuid),
      },
    }
  );


export const dryRunActivityProductImport = (
  activityUuid,
  formData,
  { companyUuid } = {}
) =>
  api.post(
    `/activities/${activityUuid}/products/import/dry-run`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        ...buildCompanyScopeHeaders(companyUuid),
      },
    }
  );


export const importActivityProducts = (activityUuid, formData, { companyUuid } = {}) =>
  api.post(`/activities/${activityUuid}/products/import`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      ...buildCompanyScopeHeaders(companyUuid),
    },
  });

export const exportActivityCsv = (activityUuid, { companyUuid } = {}) =>
  api.get(`/activities/${activityUuid}/export.csv`, {
    responseType: "blob",
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const createActivityProduct = (activityUuid, payload, { companyUuid } = {}) =>
  api.post(`/activities/${activityUuid}/products`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const updateActivityProduct = (
  activityUuid,
  productUuid,
  payload,
  { companyUuid } = {}
) =>
  api.put(`/activities/${activityUuid}/products/${productUuid}`, payload, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteActivityProduct = (activityUuid, productUuid, { companyUuid } = {}) =>
  api.delete(`/activities/${activityUuid}/products/${productUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const getActivityImports = (activityUuid, { companyUuid } = {}) =>
  api.get(`/activities/${activityUuid}/imports`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const deleteActivityImport = (activityUuid, importUuid, { companyUuid } = {}) =>
  api.delete(`/activities/${activityUuid}/imports/${importUuid}`, {
    headers: buildCompanyScopeHeaders(companyUuid),
  });

export const searchCompanies = (params, { companyUuid } = {}) =>
  api.get("/activities/companies/search", {
    params,
    headers: buildCompanyScopeHeaders(companyUuid),
  });

